




















































































































































































































































































































































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import MallConfig from '@/api/mall/mallConfig/index'
import PicModal from '@/components/upload/picModal.vue'
@Component({
  components: {
    PicModal
  }
})
export default class MemberCardSetting extends AbpBase {
  MemberCardConfig = {
    BrandName: null,
    BrandLogo: null,
    CardName: null,
    //1 true 使用背景图片 0 false 使用背景色
    IsUseBackground: 0,
    BackgroundImageUrl: null,
    BackgroundColor: null,
    //积分
    IsUseCustomField1: false,
    CustomField1: {
      NameType: '积分',
      Url: 'integral'
    },
    //等级
    IsUseCustomField2: false,
    CustomField2: {
      NameType: '等级',
      Url: 'level'
    },
    //优惠券
    IsUseCustomField3: false,
    CustomField3: {
      NameType: '优惠券',
      Url: 'coupon'
    },
    IsUseWechatPay: false,
    IsUseWechatMall: false,
    WechatMallName: null,
    WechatMallDescription: null,
    IsUseMemberCenter: false,
    MemberCenterName: null,
    MemberConterDescription: null,
    IsUseNearByShop: false,
    Notice: null,
    Description: null,
    Prerogative: null
  }

  ruleMemberCardConfig = {
    BrandName: [{ required: true, message: '请输入品牌名称', trigger: 'blur' }],
    BrandLogo: [{ required: true, message: '请选择品牌Logo', trigger: 'blur' }],
    CardName: [{ required: true, message: '请输入会员卡名', trigger: 'blur' }],
    IsUseBackground: [
      {
        required: true,
        validator: this.validateUseBackground,
        trigger: 'blur,change'
      }
    ],
    WechatMallName: [
      {
        required: true,
        validator: this.validateWechatMallName,
        trigger: 'blur,change'
      }
    ],
    MemberCenterName: [
      {
        required: true,
        validator: this.validateMemberCenterName,
        trigger: 'blur,change'
      }
    ],
    Notice: [{ required: true, message: '请输入使用提醒', trigger: 'blur' }],
    Description: [
      { required: true, message: '请输入使用说明', trigger: 'blur' }
    ],
    Prerogative: [
      { required: true, message: '请输入特权说明', trigger: 'blur' }
    ]
  }

  //验证卡片背景色
  validateUseBackground(rule, value, callback) {
    if (value == 1) {
      // 使用背景图片
      if (!this.MemberCardConfig.BackgroundImageUrl) {
        return callback(new Error('请选择背景图片'))
      } else {
        return callback()
      }
    } else {
      //使用背景色
      if (!this.MemberCardConfig.BackgroundColor) {
        return callback(new Error('请选择背景色'))
      } else {
        return callback()
      }
    }
  }

  // 验证微商城入口名
  validateWechatMallName(rule, value, callback) {
    if (!this.MemberCardConfig.IsUseWechatMall) {
      return callback()
    } else {
      if (!value) {
        return callback(new Error('请输入微商城入口名称'))
      } else {
        return callback()
      }
    }
  }

  // 验证会员中心入口名
  validateMemberCenterName(rule, value, callback) {
    if (!this.MemberCardConfig.IsUseMemberCenter) {
      return callback()
    } else {
      if (!value) {
        return callback(new Error('请输入会员中心入口名称'))
      } else {
        return callback()
      }
    }
  }

  colorList = [
    { value: 'Color010', label: '#63b359' },
    { value: 'Color020', label: '#2c9f67' },
    { value: 'Color030', label: '#509fc9' },
    { value: 'Color040', label: '#5885cf' },
    { value: 'Color050', label: '#9062c0' },
    { value: 'Color060', label: '#d09a45' },
    { value: 'Color070', label: '#e4b138' },
    { value: 'Color080', label: '#ee903c' },
    { value: 'Color081', label: '#f08500' },
    { value: 'Color082', label: '#a9d92d' },
    { value: 'Color090', label: '#dd6549' },
    { value: 'Color100', label: '#cc463d' },
    { value: 'Color101', label: '#cf3e36' },
    { value: 'Color102', label: '#5E6671' }
  ]

  get getBackground() {
    if (
      this.MemberCardConfig.IsUseBackground &&
      this.MemberCardConfig.BackgroundImageUrl
    ) {
      let background =
        'url(' +
        this.MemberCardConfig.BackgroundImageUrl +
        ') center center no-repeat'
      return background
    } else if (
      !this.MemberCardConfig.IsUseBackground &&
      this.MemberCardConfig.BackgroundColor
    ) {
      let color = ''
      this.colorList.forEach(item => {
        if (item.value == this.MemberCardConfig.BackgroundColor) {
          color = item.label
        }
      })

      return color
    }
    return ''
  }

  mounted() {
    this.getConfig('MemberCardConfig')
  }

  /**
   * 获取设置
   */
  getConfig(key) {
    MallConfig.getMallConfig(key).then(res => {
      if (res.data) {
        res.data.IsUseBackground = res.data.IsUseBackground == false ? 0 : 1
        this[key] = res.data
        this.colorChange(res.data.BackgroundColor)
      }
    })
  }

  /**
   * 卡片背景选项改变
   */
  radioChange(e) {
    if (e == 0) {
      this.colorChange(this.MemberCardConfig.BackgroundColor)
    }
  }

  /**
   * 颜色值改变
   */
  colorChange(e) {
    if (e) {
      let color = this.colorList.filter((item: any) => item.value == e)
      if (color.length == 1) {
        setTimeout(() => {
          let colorText = color[0].label
          let list: any = document.getElementsByClassName(
            'ivu-select-selected-value'
          )
          for (let i = 0; i < list.length; i++) {
            let child = list[i]
            if (
              child.offsetParent &&
              child.offsetParent.className.indexOf('ivu-select-selection') > -1
            ) {
              child.innerHTML =
                '<i style="width: 15px;height: 15px;display: inline-block;background-color:' +
                colorText +
                '"></i>'
            }
          }
        }, 100)
      }
    }
  }

  /**
   * 保存
   */
  submit() {
    let vm = this
    let cardForm: any = vm.$refs.cardForm
    cardForm.validate(valid => {
      if (valid) {
        let MemberCardConfig = JSON.parse(JSON.stringify(vm.MemberCardConfig))
        MemberCardConfig.IsUseBackground =
          vm.MemberCardConfig.IsUseBackground == 0 ? false : true

        MallConfig.updateMallConfig(
          'MemberCardConfig',
          '会员卡设置',
          MemberCardConfig
        ).then(res => {
          vm.$Notice.success({
            desc: '提交成功'
          })
          vm.getConfig('MemberCardConfig')
        })
      }
    })
  }

  /**
   * 选择背景图
   */
  picChange(e, name) {
    this.MemberCardConfig[name] = e[0].url
  }
}
